import { GrenadeObject, type GrenadeObjectOptions } from "./grenadeObject";

export class GrenadeObjectSource {
  referenceImage = new Image();

  constructor(
    private handleElement: HTMLElement,
    private GrenadeObjectClass: typeof GrenadeObject,
    private grenadeOptions: GrenadeObjectOptions = {}
  ) {
    this.referenceImage.src = this.GrenadeObjectClass.IMAGE_SRC;
    this.referenceImage.style = `position:fixed; top: -100%; left: -100%`;
    document.body.appendChild(this.referenceImage);

    this.handleElement.addEventListener("mousedown", (e) => this.spawnObject(e));
  }

  spawnObject(event: MouseEvent) {
    const droppedImage = new Image();
    droppedImage.src = this.GrenadeObjectClass.IMAGE_SRC;
    droppedImage.style = `position:fixed; top:0; left:0`;
    document.body.appendChild(droppedImage);

    const grenadeObject = new this.GrenadeObjectClass(droppedImage, {
      initialX: event.clientX - this.referenceImage.width / 2,
      initialY: event.clientY - this.referenceImage.height / 2,
      ...this.grenadeOptions,
    });

    grenadeObject.grab();
  }
}
